import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BasePricingService } from "shared/cubiq-services/lookup/pricing/impl/BasePricingService";
import { ICellRendererAngularComp } from "@bfx/ag-grid-angular";
import { PricingService } from "shared/cubiq-services";
import { LadderRate } from "shared/cubiq-services/model/orders/LadderRate";
import { LadderPair } from "shared/cubiq-services/model/orders/LadderPair";

@Component({
  selector: "market-mid",
  templateUrl: "./html/MarketMidRenderer.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MarketMidRenderer implements ICellRendererAngularComp {
  public marketMid: string;
  public showStrike: boolean;
  public visible: boolean;

  constructor(
    public cd: ChangeDetectorRef,
    protected myBasePricingService: BasePricingService,
  ) {}
  // called on init
  agInit(params: any): void {
    this.doVal(params);
    this.cd.markForCheck();
  }

  doVal(params: any): boolean {
    let changed: boolean = false;
    let newMarketMid = PricingService.clearStrikeThroughString(params.getValue(params));

    this.visible =
      params.data.constructor.name != LadderRate.name &&
      params.data.constructor.name != LadderPair.name;

    if (newMarketMid != this.marketMid) {
      changed = true;
    }

    this.marketMid = newMarketMid;
    if (this.myBasePricingService) {
      if (this.myBasePricingService.isStrikethroughMarketMid(params.data)) {
        if (this.showStrike == false) {
          changed = true;
        }
        this.showStrike = true;
      } else {
        if (this.showStrike == true) {
          changed = true;
        }
        this.showStrike = false;
      }
    }

    if (changed) {
      if (params.eGridCell != null) {
        if (this.showStrike) params.eGridCell.title = "--- " + this.marketMid + " ---";
        else params.eGridCell.title = this.marketMid;
      }
    }

    return changed;
  }

  // called when the cell is refreshed
  refresh(params: any): boolean {
    if (this.doVal(params)) {
      this.cd.markForCheck();
    }

    return true;
  }
}
